var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.129,
    height: 8.079,
    viewBox: "0 0 13.129 8.079",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16090",
    "data-name": "Rectangle 16090",
    width: 8.079,
    height: 13.129,
    transform: "translate(0 0)",
    fill: "#313131"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15402",
    "data-name": "Group 15402",
    transform: "translate(0 8.079) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15397",
    "data-name": "Group 15397",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41194",
    "data-name": "Path 41194",
    d: "M0,6.513a1.375,1.375,0,0,1,.48-.986Q2.53,3.637,4.575,1.742C5.095,1.261,5.605.768,6.138.3a1.119,1.119,0,0,1,1.8.379,1.33,1.33,0,0,1-.289,1.586Q5.614,4.161,3.574,6.041a4.408,4.408,0,0,1-.351.324c-.207.153-.163.261.008.417q2.172,1.991,4.332,4a1.374,1.374,0,0,1,.39,1.636,1.131,1.131,0,0,1-1.806.423c-.492-.429-.966-.885-1.447-1.329Q2.595,9.563.489,7.616A1.413,1.413,0,0,1,0,6.513",
    transform: "translate(0 0)",
    fill: "#313131"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlack);
export default __webpack_public_path__ + "static/media/arrow-down-black.660fd665a1be523ec4aa5537aaaa8371.svg";
export { ForwardRef as ReactComponent };